import { AppState } from 'redux/reducers';

export const getMatchStatisticsById = (placeholder: string) => (state: AppState) =>
  state.asianViewWidgets.matchStatistics[placeholder];

export const getLiveVideoById = (placeholder: string) => (state: AppState) =>
  state.asianViewWidgets.liveVideo[placeholder];
